import React from 'react';
import IndustryDetailPage from './IndustryDetailPage.jsx';

function TestimonialDistribution() {
  return <IndustryDetailPage industry="distribution" />;
}

export default TestimonialDistribution;
